import React from "react";
import { Logo } from "./logo";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header" >
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
         
          <a className="navbar-brand page-scroll" href="#page-top"  style={{
    display: "flex",
    alignItems: "center", // Vertikale Zentrierung
    justifyContent: "center", // Horizontale Zentrierung (optional)
  }}>
          <Logo logowidth="auto" logoheight={"35px"} />{" "}
             Die Containerklinik
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            {
            // <li>
             //  <a href="#features" className="page-scroll">
             //    Features
             //  </a>
            //  </li>
            }
            <li>
              <a href="#about" className="page-scroll">
                Über uns
              </a>
            </li>
            <li>
              <a href="#services" className="page-scroll">
                Unser Services
              </a>
            </li>
            <li>
              <a href="#portfolio" className="page-scroll">
                Gallery
              </a>
            </li>
            {
           //   <li>
           //   <a href="#testimonials" className="page-scroll">
           //     Testimonials
           //   </a>
           //   </li>
            }
            <li>
              <a href="#team" className="page-scroll">
                Unser Team
              </a>
            </li>
            <li>
              <a href="#contact" className="page-scroll">
                Kontakt
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
